var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px !important"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate",
      "placeholder": "Enter From Date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.submit && _vm.fromDate == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please Select From Date ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "placeholder": "Enter To Date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.submit && _vm.toDate == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Date")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hrclosedebit"
    }
  }, [_vm._v("HR Recovery")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "financerecovery"
    }
  }, [_vm._v("Finance Recovery for Partner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "financeclosed"
    }
  }, [_vm._v("Finance Closure")])]), _vm._v(" "), (_vm.submit && _vm.status == '0') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please Select status ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit From")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debitFrom),
      expression: "debitFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "debitFrom",
      "id": "debitFrom"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.debitFrom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Debit--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ServiceCenter"
    }
  }, [_vm._v("Service Center")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Courier"
    }
  }, [_vm._v("Super Agent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Coloader"
    }
  }, [_vm._v("Coloader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Vendor"
    }
  }, [_vm._v("Local Vendor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NetworkVendor"
    }
  }, [_vm._v("Network Vendor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Store"
    }
  }, [_vm._v("Store")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RSC"
    }
  }, [_vm._v("RSCOwner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BranchDebit"
    }
  }, [_vm._v("Facility / BranchDebit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Debit Ids")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.debitids),
      expression: "debitids"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "id": "de",
      "type": "text",
      "name": "debitids",
      "placeholder": "Enter Debit id"
    },
    domProps: {
      "value": (_vm.debitids)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.debitids = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.userID')),
      expression: "errors.has('form-1.userID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select From Date ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipping Id")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumbers),
      expression: "awbnumbers"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbnumbers')
    },
    attrs: {
      "rows": "4",
      "name": "awbnumbers",
      "id": "awbnumbers"
    },
    domProps: {
      "value": (_vm.awbnumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textarea-style",
    staticStyle: {
      "display": "block",
      "color": "blue"
    }
  }, [_vm._v(" (Note: Use comma (,) for multiple AWB numbers)\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    on: {
      "click": _vm.clear
    }
  }), _vm._v(" Reset")])])], 1)])])])]), _vm._v(" "), (_vm.isShow) ? _c('div', [_vm._m(4), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._l((_vm.allLedgerDetails), function(ledger, index) {
    return _c('div', {
      staticClass: "row mb-3"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('span', [_vm._v("Debit Id : "), _c('b', [_vm._v(_vm._s(ledger[0].debitid ? ledger[0].debitid : '-') + " ")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Ledger Id : "), _c('b', [_vm._v(_vm._s(ledger[0].ledgermasterid))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Debit From Type: "), _c('b', [_vm._v(_vm._s(ledger[0].debitfromtype ? ledger[0].debitfromtype : '-'))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('span', [_vm._v("Debit From  Name : "), _c('b', [_vm._v(_vm._s(ledger[0].debitfrom ? ledger[0].debitfrom : '-'))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Total Due Amount : "), _c('b', [_vm._v(_vm._s(ledger[0].totaldueamount ? ledger[0].totaldueamount : '0.00') + " ₹")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Status  : "), _c('b', [_vm._v(_vm._s(ledger[0].status ? ledger[0].status : '-'))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('span', [_vm._v("Agency Name: "), _c('b', [_vm._v(_vm._s(ledger[0].AgencyName ? ledger[0].AgencyName : '-'))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Recovery Amount : "), _c('b', [_vm._v(_vm._s(ledger[0].recoverydebitamount ? ledger[0].recoverydebitamount : 0.00) + " ₹")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Recovered By : "), _c('br'), _c('b', [_vm._v(_vm._s(ledger[0].createdby ? ledger[0].createdby : '-'))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 mb-3"
    }, [_c('span', [_vm._v("SRAgency ID: "), _c('b', [_vm._v(_vm._s(ledger[0].SRAgencyID ? ledger[0].SRAgencyID : '-'))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Opening Amount(Next-Cycle) : "), _c('b', [_vm._v(_vm._s(ledger[0].openingAmount) + " ₹")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Recovered By Date :"), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(ledger[0].createddate)) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "fold-content mb-3",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "m-2",
      staticStyle: {
        "overflow-y": "scroll"
      },
      style: ([ledger.length > 5 ? {
        height: '300px'
      } : ''])
    }, [_c('table', {
      staticClass: "small-friendly table-bordered tbl datatables fold-table",
      attrs: {
        "cellpadding": "10",
        "cellspacing": "10"
      }
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center"
    }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('b', [_vm._v("Debit Amount ")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('b', [_vm._v("Recovered Amount")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('b', [_vm._v("Remaining Amount")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('b', [_vm._v("Recovery Type")])]), _vm._v(" "), _c('th', {
      staticClass: "text-center"
    }, [_c('b', [_vm._v("Status")])])])]), _vm._v(" "), _c('tbody', [(ledger.length == 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "11"
      }
    }, [_vm._v("No Data found")])]) : _vm._e(), _vm._v(" "), _vm._l((ledger), function(shipment) {
      return _c('tr', [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(shipment.ShippingID ? shipment.ShippingID : '-'))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(shipment.DebitAmount ? shipment.DebitAmount : '0.00') + " ₹")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(" " + _vm._s(shipment.RecoveredAmount ? shipment.RecoveredAmount : '0.00') + " ₹")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(" " + _vm._s(shipment.TotalRemainingAmount ? shipment.TotalRemainingAmount : '0.00') + " ₹")]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(" " + _vm._s(shipment.status ? shipment.status : '-'))]), _vm._v(" "), _c('td', {
        staticClass: "text-center",
        class: shipment.Status == 'PartialDebit' ? 'bg-yellow' : 'bg-green'
      }, [_vm._v(_vm._s(shipment.Status ? shipment.Status : '-'))])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v("Total Recovered Amount")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b', [_vm._v(_vm._s(ledger.totalRecoverdCalculated ? ledger.totalRecoverdCalculated : 0.00) + " ₹")])])])], 2)])])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "width": "100%"
      }
    })])
  }), _vm._v(" "), (_vm.totalRecords == 0) ? _c('div', [_c('span', [_vm._v("No records found")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "100%"
    }
  })]) : _vm._e()], 2)]), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1)], 1) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Lost Recovery Summary")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("From Date "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("To  Date  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Status  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Ledger Summary")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1767a6","hasScoped":true}!./src/views/components/LOST/LostRecoverySummary/LostRecoverySummary.component.html
// module id = 1534
// module chunks = 1